import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../utils/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../utils/firebase';
import { signOut } from 'firebase/auth';

const SuperAdminAuthContext = createContext();

export function useSuperAdminAuth() {
  return useContext(SuperAdminAuthContext);
}

export function SuperAdminAuthProvider({ children }) {
  const [currentSuperAdmin, setCurrentSuperAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) setLoading(true);
      try {
        if (user) {
          const superAdminDoc = await getDoc(doc(db, 'superAdmins', user.uid));
          if (superAdminDoc.exists()) {
            setCurrentSuperAdmin({ uid: user.uid, email: user.email, ...superAdminDoc.data() });
          } else {
            const currentPath = window.location.pathname;
            if (currentPath.includes('/superadmin')) setCurrentSuperAdmin(null);
          }
        } else {
          const currentPath = window.location.pathname;
          if (currentPath.includes('/superadmin')) setCurrentSuperAdmin(null);
        }
      } catch (error) {
        console.error('SuperAdminAuthContext error:', error);
        setCurrentSuperAdmin(null);
      } finally {
        setLoading(false);
      }
    });
    return unsubscribe;
  }, []);

  const handleLogout = async () => {
    setCurrentSuperAdmin(null);
    await signOut(auth);
  };

  return (
    <SuperAdminAuthContext.Provider value={{ currentSuperAdmin, loading, logout: handleLogout }}>
      {children}
    </SuperAdminAuthContext.Provider>
  );
}
